import React from "react";
import styles from "./BrandSlider.module.css";

// Import brand logos
import sinsayLogo from "../assets/logo-sinsay.png";
import sistersLogo from "../assets/logo-sisters.png";
import forallmankindLogo from "../assets/logo-7forallmankind.png";
import urbanMonkeyLogo from "../assets/logo-urbanmonkey.svg";
import minimodeLogo from "../assets/logo-minimode.png";
import aspireLogo from "../assets/logo-aspireworkwear.png";
import bgoodLogo from "../assets/logo-bgoodfashions.png";
import donearLogo from "../assets/logo-donear.png";
import euroTexLogo from "../assets/logo-eurotex.png";
import indianArmyLogo from "../assets/logo-indianarmy.png";
import indianNavyLogo from "../assets/logo-indiannavy.png";

const logos = [
  sinsayLogo,
  sistersLogo,
  forallmankindLogo,
  urbanMonkeyLogo,
  //minimodeLogo,
  aspireLogo,
  bgoodLogo,
  donearLogo,
  euroTexLogo,
  indianArmyLogo,
  indianNavyLogo,
  sinsayLogo,
  sistersLogo,
  forallmankindLogo,
  urbanMonkeyLogo,
  //minimodeLogo,
  aspireLogo,
  bgoodLogo,
  donearLogo,
  euroTexLogo,
  indianArmyLogo,
  indianNavyLogo,
];

function BrandSlider() {
  return (
    <div className={styles.brandsCarousel}>
      <div className={styles.brandsTrack}>
        {logos.map((logo, idx) => (
          <div key={idx} className={styles.brandLogoWrapper}>
            <img src={logo} alt={`Brand logo ${idx + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default BrandSlider;